export default __webpack_public_path__ + "static/media/gallery (9).7d974fb4.png";